import { EventEmitter } from 'events'
import {
  logger
} from '../utils'

import events from './events'
import connectDefaultEventHandlers from './default.events.bind'

class Bus extends EventEmitter {
  __dispatch = (action) => {
    logger.debug(
      '[app]',
      `application initializing; skipping action[${action.type}]`
    )
  }

  // Used for ApplicationGlobalContext
  // for subscribing dispatcher for an actions
  subscribeDispatcher (dispatch) {
    // logger.debug('[app]', 'subscribing')
    this.__dispatch = dispatch
  }

  send (payload) {
    this.emit(payload.event, payload.data || payload.error)
  }

  /*
    Invokes action that will update state
   */
  invoke (action) {
    this.__dispatch(action)
  }
}

const bus = new Bus()

/*
  Setting internal events types on Bus
*/
bus.events = events

/*
  Connecting main handlers for managers binding and lifecycle
*/
connectDefaultEventHandlers(bus)

export default bus
